// components/OfflineNotification.tsx
"use client";

import { useState, useEffect } from 'react';

export default function OfflineNotification() {
  const [isOffline, setIsOffline] = useState(false);
  
  useEffect(() => {
    // Set up event listeners for online/offline events
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);
    
    // Check initial status
    setIsOffline(!navigator.onLine);
    
    // Add event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    // Cleanup
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  
  if (!isOffline) return null;
  
  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-amber-500 text-white px-4 py-2 rounded-md shadow-lg z-50">
      You are currently offline. Some features may be limited.
    </div>
  );
}

